import advent from './advent.js';

let fixedHolidays = {
  list(year) {
    let newYear = new Date(year, 0, 1);
    let kingDay = new Date(year, 3, 27);
    let liberationDay = new Date(year, 4, 5);
    let christmasDay = new Date(year, 11, 25);
    let afterChristmas = new Date(year, 11, 26);

    /*Advent days*/
    let easter = advent.easter(year);
    easter = new Date(easter);
    let goodFriday = advent.goodFriday(year).toDate();
    let ascensionDay = advent.ascension(year).toDate();
    let pentecostDay = advent.pentecost(year).toDate();

    let result = [ newYear, goodFriday, easter, ascensionDay, pentecostDay, kingDay, liberationDay, christmasDay, afterChristmas ];
    return result.sort((a, b) => a.getTime() - b.getTime());
  }
};

export default fixedHolidays;
